import React, { useEffect } from "react"
import loadable from '@loadable/component';
import SectionMainBanner from "../../molecules/section-main-banner/section-main-banner"
import SectionTheNew from "../../molecules/section-the-new/section-the-new"
import SectionVideosContent from "../../molecules/section-videos-content/section-videos-content"
import SectionFemaleCare from "../../molecules/section-female-care/section-female-care"
import SectionNosotrasNews from "../../molecules/section-nosotras-news/section-nosotras-news"
import "./home-content.scss"
import SectionProductsOutstanding from "../../molecules/section-products-outstanding/section-products-outstanding"
import SectionCompetition from "../../molecules/section-competition/section-competition"
import SectionConsulting from "../../../shared/components/molecules/section-consulting/section-consulting"
import SectionYourKeys from "../../molecules/section-your-keys/section-your-keys"
import SectionGame from "../../molecules/section-game/section-game"
// const NotificationModal = React.lazy(() =>
//   import('../../molecules/notification-modal/notification-modal')
// )
import { firebaseMessagingInit } from "../notifications-push/notifications-push"
import NewProductInfo from "../../atoms/new-product-info/new-product-info"
import { CurrentFloatingButton } from "../../atoms/floating-button/floating-button"
const SectionRelease = loadable(() => import("../../molecules/section-release/section-release"))


const HomeContent = props => {
  const {
    femaleCare,
    contennInfo,
    mobile,
    tablet,
    news,
    lanzamiento,
    videos,
    islog,
    ageSegment,
    havePoints,
  } = props

  const [showModalNotification, setShowModalNotification] = React.useState(
    false
  )
  
  useEffect(() => {
    const haveNotifications = localStorage.getItem("INFO_NOTIFICATION")
    if (haveNotifications === null) {
      setShowModalNotification({
        title: "¿Deseas recibir notificaciones?",
        description:
          "Queremos que no te pierdas nada de nuestro mundo, por eso te enterarás de nuevos concursos, productos, premios y más en NosotrasOnline",
        success: true,
      })
    }
  }, [])

  const onBloquedPermission = () => {
    setShowModalNotification({
      title: "Notificaciones Bloqueadas",
      description:
        "Para seguir disfrutando de NosotrasOnline te recomendamos activar las notificaciones",
      success: false,
    })
  }

  const handleNotification = action => {
    if (action) {
      const isIOS = !!navigator.platform && /iPhone/.test(navigator.platform)
      const isSafari = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent
      )
      if (!isIOS && !isSafari) {
        firebaseMessagingInit(onBloquedPermission)
      }
    } else {
      localStorage.setItem("INFO_NOTIFICATION", false)
    }

    setShowModalNotification(false)
  }

  const {
    tieneVConfident: haveVConfident,
    tieneSeguimientoMuestraVConfident: haveTrackSample,
  } = contennInfo.allContentfulNolPaises.nodes.filter(
    country => country.codigoIcu === process.env.LOCALE
  )[0]

  return (
    <div className="f-HomeContent">
      {/* {showModalNotification && (
        <NotificationModal
          handleNotification={handleNotification}
          onClose={() => setShowModalNotification(false)}
          title={showModalNotification.title}
          description={showModalNotification.description}
          success={showModalNotification.success}
        />
      )} */}
    {contennInfo.allContentfulNolHome.edges[0].node.tieneBotonFlotante && 
      <CurrentFloatingButton contentInfo={contennInfo.allContentfulNolHome.edges[0].node} />
    }
      {haveVConfident && <NewProductInfo haveTrackSample={haveTrackSample} />}

      <SectionMainBanner
        tiempoBanner={
          contennInfo.allContentfulNolHome.edges[0].node
            .parametrosBannerPrincipal
        }
        tablet={tablet}
        contennInfo={
          contennInfo.allContentfulNolHome.edges[0].node.bannerPrincipal
        }
        mobile={mobile}
      />

      <div className="f-HomeContent-double-section">
        <SectionTheNew
          ageSegment={ageSegment}
          news={news}
          mobile={mobile}
          islog={islog}
        />
        <SectionVideosContent videos={videos} />
      </div>
      {lanzamiento.hayLanzamiento ? (
        <SectionRelease lanzamiento={lanzamiento} mobile={mobile} />
      ) : (
        <span className="f-curve-effect">
          <span className="f-curve-child-top"></span>
        </span>
      )}

      {/* ----------------------------------------------------------------------------------------------- */}
      {/* sara */}
      {ageSegment === "Adolescente" && (
        <>
          <SectionCompetition
            classNameCategory="categoryone"
            contentInfo={contennInfo.allContentfulNolConcursos.nodes}
          />

          <div className="f-HomeContent-double-section f-HomeContent-double-section-categoryone">
            <SectionFemaleCare
              classNameCategory="categoryone"
              femaleCare={femaleCare}
              mobile={mobile}
            />
            <SectionNosotrasNews
              contennInfo={
                contennInfo.allContentfulNolHome.edges[0].node.nosotrasNews
              }
            />
          </div>

          {process.env.LOCALE === "es-CO" ? (
            <SectionYourKeys mobile={mobile} />
          ) : (
            process.env.LOCALE !== "es-PE" &&
            havePoints && <SectionYourKeys mobile={mobile} />
          )}

          {/* {
            process.env.LOCALE !== "es-PE" &&
            havePoints && <SectionYourKeys mobile={mobile} />
          } */}

          <SectionProductsOutstanding
            contentInfo={contennInfo.allContentfulNolHome.nodes[0]}
            mobile={mobile}
          />
          <span className="f-curve-effect f-curve-effect-one f-curve-effect-one-categoryone">
            <span className="f-curve-child-bottom"></span>
          </span>
          <SectionGame contentInfo={contennInfo.allContentfulNolJuegos.nodes} />
        </>
      )}

      {/* ----------------------------------------------------------------------------------------------- */}
      {/* carolina */}
      {ageSegment === "Adulto Joven" && (
        <>
          <div className="f-HomeContent-double-section ">
            <SectionFemaleCare femaleCare={femaleCare} mobile={mobile} />
            <SectionNosotrasNews
              contennInfo={
                contennInfo.allContentfulNolHome.edges[0].node.nosotrasNews
              }
            />
          </div>

          {process.env.LOCALE === "es-CO" ? (
            <SectionYourKeys mobile={mobile} />
          ) : (
            process.env.LOCALE !== "es-PE" &&
            havePoints && <SectionYourKeys mobile={mobile} />
          )}

          <SectionProductsOutstanding
            contentInfo={contennInfo.allContentfulNolHome.nodes[0]}
            mobile={mobile}
          />
          <span className="f-curve-effect f-curve-effect-one f-curve-effect-one-categoryone">
            <span className="f-curve-child-bottom"></span>
          </span>
          <SectionCompetition
            contentInfo={contennInfo.allContentfulNolConcursos.nodes}
          />
        </>
      )}

      {/* ----------------------------------------------------------------------------------------------- */}
      {/* juliana */}
      {(ageSegment === "Adulto" || ageSegment === "Anónimo") && (
        <>
          <SectionProductsOutstanding
            contentInfo={contennInfo.allContentfulNolHome.nodes[0]}
            mobile={mobile}
          />
          <div className="f-HomeContent-double-section f-background-gray">
            <SectionFemaleCare femaleCare={femaleCare} mobile={mobile} />
            <SectionNosotrasNews
              contennInfo={
                contennInfo.allContentfulNolHome.edges[0].node.nosotrasNews
              }
            />
          </div>

          {process.env.LOCALE === "es-CO" ? (
            <SectionYourKeys mobile={mobile} />
          ) : (
            process.env.LOCALE !== "es-PE" &&
            havePoints && <SectionYourKeys mobile={mobile} />
          )}

          <SectionConsulting mobile={mobile} home={true} />

          <span className="f-separator" />

          <SectionCompetition
            contentInfo={contennInfo.allContentfulNolConcursos.nodes}
          />
        </>
      )}
    </div>
  )
}
export default HomeContent
